export default "/imgs/investigation-09-mob.png"